// extracted by mini-css-extract-plugin
module.exports = {"announcement":"ProgramsBanner_announcement__qDHDJ","closeButton":"ProgramsBanner_closeButton__AMNxU"};